import React, { useState, useRef, useEffect } from 'react';
import styles from './styles';
import { connect } from 'react-redux';
import {
    Button,
    Input,
    Container,
    InputAdornment,
    IconButton,
    Typography,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import * as actionsPresentacion from '../../../actions/nuevaPresentacion';
import * as actionsInternacion from '../../../actions/internaciones';
import * as actionsVentanaDialogo from '../../../actions/ventanaDialogo';
import uploadIcono from '../../../assets/iconos/upload-icon.png';
import { TextFieldCustom } from '../../common/UI/Personalizaciones/TextField';
import DeleteIcon from '@material-ui/icons/Delete';

const NuevaInternacion = (props) => {
    const classes = styles();
    const inputAdjuntar = useRef();
    const extensionesAceptadas = '.jpg,jpeg,.png,.pdf';

    const [buscado, setBuscado] = useState(false);
    const [nroInternacionValue, setNroIntValue] = useState(
        props.internacion.nroInternacion
    );
    useEffect(() => {
        setNroIntValue(props.internacion.nroInternacion);
    }, [props.internacion.nroInternacion]);

    const filtrarArchivosPorExtension = (archivos) => {
        const archivosFiltrados = archivos.filter((archivo) => {
            const extensiones = extensionesAceptadas.split(',');
            let arcValido = false;

            for (let i = 0; i < extensiones.length; i++) {
                const extension = extensiones[i];

                if (
                    archivo.name.toLowerCase().endsWith(extension) &&
                    !props.internacion.detalles.some(
                        (arch) =>
                            arch.nombreArchivo === archivo.name &&
                            !arch.bajaLogica
                    )
                ) {
                    arcValido = true;
                    break;
                }
            }

            return arcValido;
        });

        return archivosFiltrados;
    };

    const propcesarSubidaArchivos = (archivos, index) => {
        const archivosFiltrados = filtrarArchivosPorExtension([...archivos]);

        if (archivosFiltrados.length > 0) {
            setBuscado(false);
            props.setCargaArchivosInternacion(true);
            props.cargarArchivosHandler(archivosFiltrados, index);
        } else {
            const ventanaConfig = {
                estaVisible: true,
                titulo: 'Error al procesar archivos',
                mensaje:
                    'No se procesó ninguno de los archivos seleccionados, ya que no cumplen con las extensiones soportadas [*.jpg,*.jpeg,*.png,*.pdf] o se encuentran repetidos',
                esAlerta: true,
                clickAceptar: () =>
                    props.actualizarAtriutoVentanaDialogo({
                        estaVisible: false,
                    }),
            };

            props.actualizarAtriutoVentanaDialogo(ventanaConfig);
        }
    };

    const controlNroInternacionNoRepetido = (nroInternacion) => {
        let esValido = true;

        for (let i = 0; i < props.internaciones.length; i++) {
            const internacion = props.internaciones[i];

            if (
                parseInt(nroInternacion) === parseInt(internacion.nroInternacion) &&
                !internacion.bajaLogica
            ) {
                esValido = false;
                break;
            }
        }

        return esValido;
    };

    const mostrarBtnHabilitado = (habilitado) => {
        if (!habilitado) {
            inputAdjuntar.current.className =
                inputAdjuntar.current.className + ' Mui-disabled';
        } else {
            inputAdjuntar.current.className = inputAdjuntar.current.className.replace(
                'Mui-disabled',
                ''
            );
        }
    };

    const buscarInformacion = (codPrestador, nroInternacion) => {
        setBuscado(true);
        const esValido = controlNroInternacionNoRepetido(nroInternacion);

        if (nroInternacion === '') {
            props.actualizarMensajesError(
                'nroInternacionNueva',
                `Ingrese ${props.idPresentacion===3?"DNI de socio":"Nº internación"}`
            );
            mostrarBtnHabilitado(false);
        } else if (esValido) {
            props.recuperarInformacionHandler(codPrestador, nroInternacion);
            props.actualizarMensajesError('nroInternacionNueva', null);
            mostrarBtnHabilitado(true);
        } else {
            props.actualizarMensajesError(
                'nroInternacionNueva',
                `${props.idPresentacion===3?"DNI de socio":"Nº de internación"} repetido`
            );
            mostrarBtnHabilitado(false);
        }
    };

    const filtrarCaracteresCampoNumerico = (event) => {
        if (event.key.toLowerCase() === 'e' || event.key === '.') {
            event.preventDefault();
        }
    };

    const mostrarInputNombreApellido = () => {
        if (
            buscado &&
            props.internacion.nroInternacion &&
            props.internacion.nombreCompleto === ''
        ) {
            return (
                <div className={classes.containerNroInvalido}>
                    <Typography className={classes.nroInvalido}>
                        Asociado no encontrado
                    </Typography>
                </div>
            );
        }

        return (
            <TextFieldCustom
                label='Nombre y apellido'
                variant='outlined'
                size='small'
                className={classes.nombreSocio}
                disabled
                value={
                    props.internacion ? props.internacion.nombreCompleto : ''
                }
            />
        );
    };

    const ocultarNuevaInternacion = () => {
        setBuscado(false);
        props.actualizarMensajesError('nroInternacionNueva', null);
        props.mostrarHandler();
        props.reiniciarNuevaPresentacion();
    };

    if (!props.mostrar) {
        return null;
    }

    return (
        <Container disableGutters={true} className={classes.container}>
            <IconButton
                size='small'
                onClick={ocultarNuevaInternacion}
                className={classes.containerAlineado}
            >
                <DeleteIcon fontSize='small' />
            </IconButton>
            <TextFieldCustom
                label={`${props.idPresentacion===3?"DNI de socio":"Nº socio"}`}
                variant='outlined'
                type='number'
                size='small'
                className={classes.nroInternacion}
                required
                id='nroInternacionInput'
                value={nroInternacionValue ?? ""}
                onChange={(event) => setNroIntValue(event.target.value)}
                onBlur={(event) =>
                    buscarInformacion(props.codPrestador, event.target.value)
                }
                onKeyPress={(event) => filtrarCaracteresCampoNumerico(event)}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position='end'>
                            <IconButton size='small'>
                                <SearchIcon fontSize='small' />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                error={!!props.errorMensaje.nroInternacionNueva}
                helperText={
                    props.errorMensaje.nroInternacionNueva &&
                    props.errorMensaje.nroInternacionNueva
                }
            />
            {mostrarInputNombreApellido()}
            <Button
                variant='outlined'
                component='label'
                className={classes.btnAdjuntar}
                disabled={!buscado}
                ref={inputAdjuntar}
            >
                <Input
                    id={'icon-button-file-' + props.index}
                    type='file'
                    disabled={!buscado}
                    onChange={(event) => {
                        propcesarSubidaArchivos(event.target.files);
                    }}
                    inputProps={{
                        accept: extensionesAceptadas,
                        multiple: true,
                        hidden: true,
                    }}
                />
                <img
                    src={uploadIcono}
                    alt='Subir archivo'
                    className={classes.iconoUpload}
                />
                Elegí un archivo
            </Button>
        </Container>
    );
};

const mapStateToProps = (state) => ({
    errorMensaje: state.nuevaPresentacionReducer.errorMensaje,
    internaciones: state.nuevaPresentacionReducer.internaciones,
});

const actionCreators = {
    actualizarMensajesError: actionsPresentacion.actualizarMensajesError,
    setCargaArchivosInternacion: actionsInternacion.setCargaArchivosInternacion,
    actualizarAtriutoVentanaDialogo:
        actionsVentanaDialogo.actualizarAtriutoVentanaDialogo,
    reiniciarNuevaPresentacion: actionsInternacion.reiniciarNuevaPresentacion,
};

export default connect(mapStateToProps, actionCreators)(NuevaInternacion);
